var ThemeColor;
(function (ThemeColor) {
  ThemeColor["light"] = "white";
  ThemeColor["dark"] = "#24272c";
})(ThemeColor || (ThemeColor = {}));

export { ThemeColor };
